import { CustomTableColumn } from "./custom-table-column";

export class DatetimeTableColumn extends CustomTableColumn {
    format: string;

    constructor(name: string, label: string, path: string, format: string) {
        super(name, label, path);
        this.format = format;
    }
}
